<template>
    <g fill="none" stroke="#333333">
        <circle cx="3.5" cy="3" r="1.5" />
        <path d="M4.5 3.3 L15 9 L4.5 14.7"/>
        <circle cx="3.5" cy="15" r="1.5" />
    </g>

</template>